/**
 * Reports-and-resources template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import './partials/InteractiveMap';
import './partials/InteractiveMapMetricSelector';
import './partials/MapDownload';
import { gsap, DrawSVGPlugin } from 'gsap/all';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Reports-and-resources-new';

const printCommandDom = document.querySelector(`[data-print-command]`);

const copyLinkDom = document.querySelector(`.reports-and-resources__hero-banner__links-wrap__link__a[title="Link"]`);

const shareFacebookDom = document.querySelector(`[data-share-facebook]`);
const shareLinkedInDom = document.querySelector(`[data-share-linkedin]`);
const shareXDom = document.querySelector(`[data-share-x]`);

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

// Bootstrap global functionality
Global();
gsap.registerPlugin(DrawSVGPlugin);


/**
 * init --- Initialize the view
 */
function init() {
	Logger.log(NAME + ' > init');
	/* sticky hero banner */
	const stickySection = document.querySelector('.reports-and-resources__section:has(.reports-and-resources__hero-banner)');
	const banner = stickySection.querySelector('.reports-and-resources__hero-banner');
	const stickyCallback = (entries) => {
		entries.forEach(entry => {
			banner.classList.toggle('is-sticky', entry.isIntersecting);
		})
	};
	let stickyObserver = new IntersectionObserver(stickyCallback, { threshold: 0, rootMargin: `0px 0px -${window.visualViewport.height - (window.visualViewport.width < 960 ? 57 : 101)}px 0px` });
	stickyObserver.observe(stickySection);
	//
	const onResize = () => {
		stickyObserver.unobserve(stickySection);
		stickyObserver = null;
		stickyObserver = new IntersectionObserver(stickyCallback, { threshold: 0, rootMargin: `0px 0px -${window.visualViewport.height - (window.visualViewport.width < 960 ? 57 : 101)}px 0px` });
		stickyObserver.observe(stickySection);
	}
	window.addEventListener('resize', onResize);
	//
	const countrySelector = document.querySelector('.reports-and-resources__interactive-map--country-selector');
	let countrySelectorTop;
	const countryCallback = (entries) => {
		entries.forEach(entry => {
			countrySelectorTop = countrySelector.getBoundingClientRect().top;
			banner.classList.toggle('show-select', entry.isIntersecting || countrySelectorTop < 20);
		})
	};
	const countryObserver = new IntersectionObserver(countryCallback, { threshold: 0, rootMargin: `0px 0px -96% 0px` });
	countryObserver.observe(countrySelector);

	/* country forms */
	const countryRadioForm = document.getElementById('country-radio-form');
	const countrySelectForm = document.getElementById('country-select-form');
	countryRadioForm.addEventListener('change', (e) => {
		countrySelectForm[0].value = e.target.value;
	});
	countrySelectForm.addEventListener('change', (e) => {
		countryRadioForm.querySelector(`input[value="${e.target.value}"]`).checked = true;
	});

	/* animate block-trend-line-compare */
	const observerCallback = (entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.querySelectorAll('.graph polyline').forEach(line => {
					const texts = Array.from(entry.target.querySelectorAll(`.graph text.${line.className.baseVal}`));
					gsap.fromTo(line, { drawSVG: '0%' }, { drawSVG: '100%', duration: texts.length * 0.43, ease: 'none' });
					gsap.fromTo(texts, { opacity: 0 }, {
						opacity: 1,
						duration: 0.2,
						ease: 'none',
						stagger: {
							each: 0.43,
						}
					});
				});
			}
		})
	};
	const observer = new IntersectionObserver(observerCallback, { threshold: 0.1, rootMargin: '-40% 0px' });
	document.querySelectorAll('block-trend-line-compare').forEach(el => {
		el.addEventListener('built', () => {
			el.querySelectorAll('.graph polyline').forEach(line => {
				const texts = Array.from(el.querySelectorAll(`.graph text.${line.className.baseVal}`));
				gsap.set(line, { drawSVG: 0 });
				gsap.set(texts, { opacity: 0 });
			});
			observer.observe(el);
		})
	});


	// Print command
	// if (printCommandDom) {
	// 	printCommandDom.querySelector('a').addEventListener('click', (e) => {
	// 		e.preventDefault();
	// 		window.print();
	// 	});
	// }

	// Copy link
	if (copyLinkDom) {
		copyLinkDom.addEventListener(`click`, (e) => {
			e.preventDefault();

			// Get current url and copy it to clipboard
			const currentUrl = window.location;
			navigator.clipboard.writeText(currentUrl);

			const originalText = copyLinkDom.innerHTML;
			copyLinkDom.innerHTML = `Copied!`;
			setTimeout(() => {
				copyLinkDom.innerHTML = originalText;
			}, 4000);

		});
	}
}


init();


// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
